import React from 'react';
import { Container, Box, Typography, TextField, Radio, RadioGroup, FormControlLabel, Divider } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useThemeContext } from '../context/ThemeContext';
import { FaFacebook, FaWhatsappSquare } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { Button } from '@mui/joy';


const Login = () => {
    const {isXs,isSM, isSm, isMd, isLg} =useThemeContext()
  return (
    <Container sx={{ mt: 5, p:2 ,width:isSM? '100%' : isMd ? '578px' :  '578px',}}>
     
      <Box textAlign="center" mb={3}>
        <Typography variant="h5">
          <NavLink to="/" style={{ textDecoration: 'none', color: '#000' }}>Login</NavLink> / 
          <NavLink to="/" style={{ textDecoration: 'none', color: '#000' }}>Sign Up</NavLink>
        </Typography>
      </Box>
      <form>
        <Box mb={2}>
          <TextField
   
            placeholder="Enter Your Phone Number"
            variant="outlined"
            
            
            sx={{width: isSM? '100%' : isMd ? '578px' :'578px',height: '59px',
            '& .MuiOutlinedInput-root': {
            '&.Mui-focused': {
              outline: 'none', 
              borderColor: 'transparent',
            },
          },
            }}
          />
        </Box>

        <RadioGroup row>
          <FormControlLabel value="fundi" control={<Radio />} label="Looking For a Fundi?" />
          <FormControlLabel value="areYouFundi" control={<Radio />} label="Are you Fundi" />
        </RadioGroup>


        <Divider component="li"  sx={{ my: 2,color:'#666666'}}>Login with Others</Divider>
        
        <Button
        sx={{
          width: isSM? '100%' : isMd ? '578px' :  '578px',
          height: '72px',
          padding:isXs
            ? '0' 
            : isSm
            ? '10px 20px' 
            : isMd
            ? '14px 40px' 
            : '19px 118px 20px 118px',
            
          borderRadius: '12px',
          color:'#fff',
          border: '1px solid #666666',
          marginTop: '30px',
          background: '#28A745',
          fontFamily: 'Montserrat',
          fontSize: isXs
            ? '14px'
            :isSm
            ? '14px'
            : isMd
            ? '16px'
            : isLg
            ? '18px'
            : '24px',
          fontWeight: 400,
          lineHeight: '29.26px',
          textUnderlinePosition: 'from-font',
          textDecorationSkipInk: 'none',
          '&:hover': {
            backgroundColor: '#28A745',
          },
        }}
      >
       Continue
      </Button>

      <Button
        variant="outlined"
     sx={{
    width: isSM? '100%' : isMd ? '578px' : '578px',
    height: '72px',
    padding: isXs
      ? '0'
      :isSM
      ?'2px'
      : isMd
      ? '14px 40px'
      : '19px 118px 20px 118px',
    borderRadius: '12px',
    color: '#666666',
    border: '1px solid #666666',
    marginTop: '30px',
    background: '#fff',
    fontFamily: 'Montserrat',
    fontSize: isXs? '14px': isSm? '14px': isMd? '16px': isLg? '18px': '24px',
    fontWeight: 400,
    lineHeight: '29.26px',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    '&:hover': {
      backgroundColor:'#fff',
    },
    mt: 2,
  }}
  startDecorator={<FaFacebook color="#0C82EE" size={24} />}
>
  Continue with Facebook
</Button>

<Button
        variant="outlined"
     sx={{
    width: isSM? '100%' : isMd ? '578px' : '578px', 
    height: '72px',
    padding: isXs? '0':isSM ?'2px': isMd ? '14px 40px': '19px 118px 20px 118px',
    borderRadius: '12px',
    color: '#666666',
    border: '1px solid #666666',
    marginTop: '30px',
    background: '#fff',
    fontFamily: 'Montserrat',
    fontSize: isXs
      ? '14px'
      : isSm
      ? '14px'
      : isMd
      ? '16px'
      : isLg
      ? '18px'
      : '24px',
    fontWeight: 400,
    lineHeight: '29.26px',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    '&:hover': {
      backgroundColor:'#fff',
    },
   mt: 2,
  }}
  startDecorator={<FcGoogle size={24} />}
>
Continue with Google
</Button>
<Button
        variant="outlined"
     sx={{
    width: isSM? '100%' : isMd ? '578px' : '578px',
    height: '72px',
    padding: isXs
      ? '0'
      :isSM
      ?'2px'
      : isMd
      ? '14px 40px'
      : '19px 118px 20px 118px',
    borderRadius: '12px',
    color: '#666666',
    border: '1px solid #666666',
    marginTop: '30px',
    background: '#fff',
    fontFamily: 'Montserrat',
    fontSize: isXs
      ? '14px'
      : isSm
      ? '12px'
      : isMd
      ? '16px'
      : isLg
      ? '18px'
      : '24px',
    fontWeight: 400,
    lineHeight: isSM?'15.26px':'29.26px',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    '&:hover': {
      backgroundColor:'#fff',
    },
   mt: 2,
  }}
  startDecorator={<FaWhatsappSquare color="#00D95F" size={24} />}
>
Continue with WhatsApp
</Button>
       

      </form>
            
    </Container>
  );
};

export default Login;


